import React from 'react';
import { makeStyles } from '@material-ui/core';

import { useIntl } from 'ha/i18n';
import { Link, units } from '@ha/dsl';
import Img from 'ha/ui/next/Img';
import Track from 'ha/components/track/SmartTrack';
import haLogo from 'img-src/logos/housing-anywhere-logo.svg';
import HousingAnywhereIcon from 'custom-icons/housing-anywhere-icon.svg';

interface Props {
  showOnlyIcon?: boolean;
}

const useStyles = makeStyles(theme => ({
  iconLink: {
    display: 'flex',
  },
  icon: {
    fontSize: units.rem(2.4),
    color: theme.palette.orange.main,
  },
}));

export const NavBarLogo: React.FC<Props> = ({ showOnlyIcon }) => {
  const { urlResolver } = useIntl();
  const classes = useStyles();

  return (
    <Track name="Clicked Logo in header" type="icon">
      <Link
        to={urlResolver.getHomeUrl()}
        className={showOnlyIcon ? classes.iconLink : undefined}
        data-test-locator="HA Logo"
      >
        {showOnlyIcon ? (
          <HousingAnywhereIcon color="secondary" className={classes.icon} />
        ) : (
          <Img src={haLogo} alt="HousingAnywhere" />
        )}
      </Link>
    </Track>
  );
};

export default NavBarLogo;
